import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=1fa7facf&scoped=true&"
import script from "./Search.vue?vue&type=script&lang=js&"
export * from "./Search.vue?vue&type=script&lang=js&"
import style0 from "./Search.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Search.vue?vue&type=style&index=1&id=1fa7facf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa7facf",
  null
  
)

export default component.exports